<template>
<section>
  <div class="banner-main">
    <div class="banner-main-img">
      <img src="/images/back.webp">
    </div>
    <div class="banner-door">
      <img class="banner_door_img" src="/images/door.webp">
    </div>
    <div class="banner-door banner_door_anchor" @mouseover="showInfo = true" 
    @mouseleave="showInfo = false">
      <a href="javascript:;" @click="jerkDoor">
        <img src="/images/door.webp">
      </a>
    </div>
    <div class="banner-info" v-if="showInfo">
      <label>tu ne cede malis sed contra audentior ito</label>
    </div>
    <div class="banner-button">
      <a href="javascript:;" @click="openDoor">
        <i class="bi bi-shield-lock-fill"></i>
      </a>
    </div>
  </div>
</section>

</template>

<script>
export default {
  name: "HeroSection",
  data() {
    return {
      showInfo: false, // Reactive property to control visibility
    };
  },
  methods: {
    jerkDoor() {
      const door = document.querySelector(".banner_door_img");
      door.classList.add("jerk-animation");
      setTimeout(function(){
        door.classList.remove("jerk-animation");
      },500)
    },
    openDoor() {
      document.querySelector(".banner-button").style.display = 'none';
      document.querySelector(".banner_door_anchor").style.display = 'none';
      const door = document.querySelector(".banner_door_img");
      door.classList.add("open-animation");
      setTimeout(() => {
        door.parentNode.classList.add("zoom-animation");
        document.querySelector(".banner-main-img").classList.add('background-animation');
      }, 1200 );
      setTimeout(() => {
        this.$router.push("/next");
      }, 3000 );
    },
  },
};
</script>

<style scoped>

.banner_door_anchor {
  z-index: 1;
}
.banner-button {
  z-index: 10;
}
.banner_door_anchor img {
  opacity: 0;
}

.jerk-animation {
  animation: shake .3s;
}
/* Keyframes for Jerk Animation */
@keyframes shake {
  0% { transform: translate(1px, 1px) rotate(0deg); }
  10% { transform: translate(1px, 2px) rotate(0deg); }
  20% { transform: translate(2px, 0px) rotate(0deg); }
  30% { transform: translate(2px, 2px) rotate(0deg); }
  40% { transform: translate(1px, 1px) rotate(0deg); }
  50% { transform: translate(1px, 2px) rotate(0deg); }
  60% { transform: translate(2px, 1px) rotate(0deg); }
  70% { transform: translate(2px, 1px) rotate(0deg); }
  80% { transform: translate(1px, 1px) rotate(0deg); }
  90% { transform: translate(1px, 2px) rotate(0deg); }
  100% { transform: translate(1px, 2px) rotate(0deg); }
}
.open-animation {
  transform-origin: left;
  transition: all 1.5s ease-in-out;
  transform: perspective(1200px) translateZ(0px) translateX(-25px) translateY(-30px) rotateY(75deg);
}
.zoom-animation {
  transform-origin: left;
  transition: all 2.4s ease-in-out;
  transform: scale(5.5) translate(-50%, -90px);
  left: -50%;
}
.background-animation {
  transform-origin: left;
  transition: all 2.5s ease-in-out;
  transform: scale(10.5) translate(-50%, -90px)
}

.banner-button a i::before {
  animation: boxShadow 5s infinite;
  border-radius: 50px;
}

.banner-info {
  position: absolute;
  right: 0;
  margin: 0 auto;
  display: table;

  top: 30%;
  left: 11%;
  background: black;
  padding: 10px;
  border-radius: 10px;
  box-shadow: rgb(255 255 255 / 24%) 0px 3px 13px 9px;
  z-index: 0;
}

@keyframes boxShadow {
  50% {box-shadow: white -3px 0px 25px 10px;}
}

</style>